import React from "react";
import { Autocomplete, Button, styled } from "@mui/material";

const CustomAutoComplete = styled(Autocomplete)({
  background: '#fff',
    borderRadius: "10px",
    border: '1px solid #e6e7e9',
});
export default CustomAutoComplete;
